/**
 * Online gateway buttons (eSewa, Khalti, connectIPS, Fonepay) are mock-backed for now.
 * Disabled in production builds unless explicitly re-enabled via env.
 */
export function isOnlinePaymentsEnabled(): boolean {
  if (process.env.REACT_APP_ONLINE_PAYMENTS_ENABLED === 'true') return true;
  if (process.env.REACT_APP_ONLINE_PAYMENTS_ENABLED === 'false') return false;
  return process.env.NODE_ENV !== 'production';
}
